<template>

  <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-0 mt-5">

    <v-layout align-center wrap style="min-height: 48px;" v-if="box.title">
      <v-flex xs12 class="text-xs-left" >
        <div><h3 class="title pl-3">{{box.title}}</h3></div>

      </v-flex>

    </v-layout>
    <v-card style="border-radius: 3px; border: 1px solid lightgray;" class="elevation-0">

      <v-layout
        text-xs-justify
        wrap
      >

        <v-flex md8 xs12 order-md2 order-xs2>
          <v-card-text class="pa-0">
            <v-expansion-panel v-model="tabs" class="elevation-0">
              <v-expansion-panel-content
                v-for="(page, i) in box.pages"
                :key="'page-'+i"
              >
                <template v-slot:header>
                  <div><h3 class="title font-weight-regular mb-0">{{page.title}}</h3></div>
                </template>
                <v-card>
                  <v-card-text class="pt-0 text-xs-justify" >
                    <div class="body-1">{{ page.text }}</div>


                  </v-card-text>

                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider></v-divider>
            <v-card-actions class=" mt-1 pa-2" :class="$vuetify.breakpoint.smAndDown ? '' : 'right'" >

              <v-btn class="ma-0 " :block="$vuetify.breakpoint.smAndDown ? true : false"   large dark  style="background-color: rgb(237, 24, 72) !important; border-color: rgb(237, 24, 72) !important;" :to="{name: 'page', params: {box: box}}">Learn More</v-btn>

            </v-card-actions>
          </v-card-text>


        </v-flex>
        <v-flex md4 xs12 order-md1 order-xs1 class="grey darken-3">
          <v-img style="min-height: 100%;"
                 :src="require('@/assets/'+image)"
                 aspect-ratio="2.75"
          ></v-img>
        </v-flex>
      </v-layout>

    </v-card>

    <v-card-actions v-if="false" class=" mt-1 pa-2" :class="$vuetify.breakpoint.smAndDown ? '' : 'right'" >

      <v-btn class="ma-0 " :block="$vuetify.breakpoint.smAndDown ? true : false"  large dark  style="background-color: rgb(237, 24, 72) !important; border-color: rgb(237, 24, 72) !important;" :to="{name: 'page', params: {box: box}}">Learn More</v-btn>

    </v-card-actions>

  </v-flex>

</template>

<script>
export default {
  props: {
    box: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      image: 'transparent.png',
      tabs: 0,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  mounted () {
    this.updateImage()
  },
  methods: {
    openFullPage () {
      this.$router.push(this.$router.currentRoute.path + '#details')
    },
    next () {
      const active = parseInt(this.tabs)
      this.tabs = (active < 2 ? active + 1 : 0)
    },
    updateImage () {
      if (this.box.pages[this.tabs]) {
        if (this.box.pages[this.tabs].image) {
          this.image = this.box.pages[this.tabs].image
        } else {
          this.image = 'transparent.png'
        }
      }
    }
  },
  watch: {
    'tabs': function () {
      this.updateImage()
    }
  }
}
</script>

<style>
  .v-expansion-panel__header {
    padding: 16px;
  }

  .v-tabs__item--active {
    color: red;
  }

  .v-window__container--is-active, .v-window__container, .v-window-item, .v-window {
    height: 100% !important;
  }
</style>
